import React from 'react';
import { useTranslation } from 'react-i18next';

import SilaNavTabs from '../../components/common/SilaNavTabs';
import InstantSettlementForm from '../../components/admin/InstantSettlementForm';
import CompanyWalletForm from '../../components/admin/CompanyWalletForm';
import CompanyWalletsTable from '../../components/admin/CompanyWalletsTable';

function OperationalWallets({ app, getApplication }) {
  const { t } = useTranslation();

  let crwComponent = <CompanyWalletForm app={app} onSave={getApplication} />;
  if (app.instant_settlement) {
    crwComponent = <InstantSettlementForm initialValues={app} onSave={getApplication} />;
  }
  const tabs = [
    {
      key: 'bows',
      label: t('admin.applications.operationalWallets.bows'),
      component: <CompanyWalletsTable app={app} onSave={getApplication} />,
    },
    {
      key: 'crw',
      label: t('admin.applications.operationalWallets.crw'),
      component: crwComponent,
    },
  ];

  return <SilaNavTabs tabs={tabs} defaultTab="bows" />;
}

export default OperationalWallets;
